import React, { useState } from "react";
import Breadcrumbs from "../../components/pageProps/Breadcrumbs";
import { FaYoutube, FaLinkedin, FaFacebook, FaInstagram, FaQuora, FaTwitter, FaSkype, FaMapMarkerAlt } from "react-icons/fa";
import { Helmet } from "react-helmet";
import Image from "../../components/designLayouts/Image";
import { worldCountries, worldsearoutemap } from "../../assets/images";

const Contact = () => {
  const [successMsg, setSuccessMsg] = useState("");

  const socialIcons = {
    linkedin: { icon: FaLinkedin, color: "#0a66c2" },
    youtube: { icon: FaYoutube, color: "#FF0000" },
    facebook: { icon: FaFacebook, color: "#0866FF" },
    instagram: { icon: FaInstagram, color: "#E1306C" },
    quora: { icon: FaQuora, color: "#AA2200" },
    twitter: { icon: FaTwitter, color: "#00ACEE" },
    skype: { icon: FaSkype, color: "#00aff0" },
  };

  return (
    <div className="max-w-container mx-auto px-4">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Contact Us - RK Global Trader | Export from India</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta
          name="description"
          content="Get in touch with RK Global Trader for export inquiries, customer support, partnership opportunities, or product information. Reliable international trade support from India."
        />
        <meta
          name="keywords"
          content="RK Global Trader contact, export business support, international trade inquiries, agriculture export India, customer service, partnership, export products, certified exporters, global trade solutions"
        />
        <meta
          name="author"
          content="RK Global Trader | Agriculture Export | Export from India"
        />
        <link rel="canonical" href="https://www.rkglobaltrader.com/contact" />
      </Helmet>

      <Breadcrumbs title="Contact Us" />

      {successMsg ? (
        <p className="pb-20 w-96 font-medium text-green-500">{successMsg}</p>
      ) : (
        <div className="pb-10">
          {/* Introduction */}
          <div className="pl-4 pr-4 sm:pl-0 sm:pr-0 mb-6">
            <h1 className="text-primeColor font-semibold text-lg mb-2">Contact RK Global Trader</h1>
            <p className="text-sm sm:text-base text-lightText text-justify">
              We are here to assist with export services, partnership opportunities, and product inquiries. Choose your preferred method to connect with our expert team.
            </p>
          </div>

          {/* Contact Options */}
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
            {/* General Inquiries */}
            <div className="border p-4 rounded-md shadow-sm">
              <h2 className="text-primeColor font-semibold text-lg mb-2">General Inquiries</h2>
              <p className="text-base text-lightText mb-2">
                Reach out for general questions about our services and international trade.
              </p>
              <ul className="list-disc pl-5 space-y-1">
                <li><strong>Email:</strong> sales@rkglobaltrader.com</li>
                <li><strong>Phone:</strong> +91-9860968617</li>
              </ul>
            </div>

            {/* Customer Support */}
            <div className="border p-4 rounded-md shadow-sm">
              <h2 className="text-primeColor font-semibold text-lg mb-2">Customer Support</h2>
              <p className="text-base text-lightText mb-2">
                Assistance with your orders, shipments, or product-related inquiries.
              </p>
              <ul className="list-disc pl-5 space-y-1">
                <li><strong>Email:</strong> sales@rkglobaltrader.com</li>
                <li><strong>Phone:</strong> +91-9860968617</li>
              </ul>
            </div>

            {/* Visit Us */}
            <div className="border p-4 rounded-md shadow-sm">
              <h2 className="text-primeColor font-semibold text-lg mb-2">Visit Us</h2>
              <p className="text-base text-lightText mb-2">
                Schedule an appointment to visit our offices for export consultations.
              </p>
              <p>
                Gat No-720,721,723(P),733, FERONIA-506, Nyati Elan, Wagholi-Pune, Maharashtra, India - 412207
              </p>
            </div>

            {/* Social Media */}
            <div className="border p-4 rounded-md shadow-sm col-span-1 md:col-span-2 xl:col-span-1">
              <h2 className="text-primeColor font-semibold text-lg mb-2">Connect on Social Media</h2>
              <p className="text-base text-lightText mb-2">
                Follow us for updates on products, trade news, and company announcements.
              </p>
              <ul className="flex flex-wrap gap-4 mt-2">
                <li>
                  <a href="https://www.linkedin.com/company/rkglobaltraderexportimport" target="_blank" rel="noreferrer">
                    <FaLinkedin style={{ color: socialIcons.linkedin.color, fontSize: "1.4em" }} />
                  </a>
                </li>
                <li>
                  <a href="https://twitter.com/RKGlobalTrader" target="_blank" rel="noreferrer">
                    <FaTwitter style={{ color: socialIcons.twitter.color, fontSize: "1.4em" }} />
                  </a>
                </li>
                <li>
                  <a href="https://join.skype.com/invite/y2aKja4bOc03" target="_blank" rel="noreferrer">
                    <FaSkype style={{ color: socialIcons.skype.color, fontSize: "1.4em" }} />
                  </a>
                </li>
                <li>
                  <a href="https://www.youtube.com/channel/UCEF5TbZReaHEcHKs36ceqXw" target="_blank" rel="noreferrer">
                    <FaYoutube style={{ color: socialIcons.youtube.color, fontSize: "1.4em" }} />
                  </a>
                </li>
                <li>
                  <a href="https://www.facebook.com/profile.php?id=61554237851124" target="_blank" rel="noreferrer">
                    <FaFacebook style={{ color: socialIcons.facebook.color, fontSize: "1.4em" }} />
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/rkglobaltrader_export_import/" target="_blank" rel="noreferrer">
                    <FaInstagram style={{ color: socialIcons.instagram.color, fontSize: "1.4em" }} />
                  </a>
                </li>
                <li>
                  <a href="https://www.quora.com/profile/RK-Global-Trader" target="_blank" rel="noreferrer">
                    <FaQuora style={{ color: socialIcons.quora.color, fontSize: "1.4em" }} />
                  </a>
                </li>
              </ul>
            </div>

            {/* Office Hours */}
            <div className="border p-4 rounded-md shadow-sm">
              <h2 className="text-primeColor font-semibold text-lg mb-2">Office Hours</h2>
              <p className="text-base text-lightText">Monday to Saturday: 9:00 AM - 11:00 PM (IST)</p>
            </div>

            {/* Feedback */}
            <div className="border p-4 rounded-md shadow-sm">
              <h2 className="text-primeColor font-semibold text-lg mb-2">Feedback</h2>
              <p className="text-base text-lightText">
                Share your suggestions and comments to help us improve our services: <strong>sales@rkglobaltrader.com</strong>
              </p>
            </div>
          </div>

          {/* Map & Emergency Contact */}
          <div className="px-0 sm:pl-11 sm:pr-11 mt-6 sm:mt-10">
            <h2 className="text-primeColor font-semibold text-base sm:text-lg mb-2 text-center sm:text-left">
              Our Location
            </h2>

            <div className="relative">
              <Image className="m-auto max-w-full" imgSrc={worldCountries} />
              <FaMapMarkerAlt className="pointermark absolute top-1/2 left-1/2 transform 
      -translate-x-1/2 -translate-y-1/2 text-red-600 text-xl sm:text-2xl" />
            </div>

            <h2 className="text-primeColor font-semibold text-base sm:text-lg mt-4 sm:mt-6 mb-2 text-center sm:text-left">
              Emergency Contact
            </h2>

            <p className="text-sm sm:text-base text-lightText text-center sm:text-left px-2 sm:px-0">
              For urgent matters outside office hours, call our emergency hotline:
              <span className="font-medium"> +91-9860968617</span>
            </p>

            <h2 className="text-primeColor font-semibold text-base sm:text-lg mt-4 sm:mt-6 mb-2 text-center sm:text-left">
              World Sea Routes
            </h2>

            <div className="relative">
              <Image className="m-auto max-w-full" imgSrc={worldsearoutemap} />
            </div>
          </div>

        </div>
      )}
    </div>
  );
};

export default Contact;
